import { useInView } from "framer-motion";
import { useEffect, useRef } from "react";
import { analytics, type MetricName } from "@/lib/analytics";

interface UseTrackWhenInViewOptions {
  threshold?: number;
}

export function useTrackWhenInView<T extends HTMLElement = HTMLElement>(
  eventName: string,
  params?: UseTrackWhenInViewOptions,
) {
  const ref = useRef<T>(null);
  const hasTracked = useRef(false);
  const isInView = useInView(ref, {
    amount: params?.threshold ?? 0.3,
  });

  useEffect(() => {
    if (isInView && !hasTracked.current) {
      hasTracked.current = true;
      analytics.trackFunnelEvent(eventName as MetricName);
    }
  }, [isInView, eventName]);

  return ref;
}
